(function () {
  if (window.PinmeUI) return;

  const doc = document;
  const root = doc.documentElement;
  const state = {
    locks: new Set(),
    saved: null,
    revealObserver: null,
    revealSeen: new WeakSet(),
    revealResumeTimer: null,
  };
  const formReturnKeys = {
    source: 'pinme_form_return_source',
    newsletterSource: 'pinme_newsletter_source',
    x: 'pinme_form_return_scroll_x',
    y: 'pinme_form_return_scroll_y',
    time: 'pinme_form_return_time',
  };
  const formReturnWindow = 5 * 60 * 1000;

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const getSessionItem = (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };
  const setSessionItem = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  };
  const removeSessionItem = (key) => {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      return;
    }
  };
  const hasCustomerPostedFlag = () => /(?:\?|&)customer_posted=true(?:&|$)/.test(window.location.search)
    || window.location.hash.toLowerCase().includes('contact_form');
  const readFormReturn = () => {
    const source = getSessionItem(formReturnKeys.source);
    const time = Number(getSessionItem(formReturnKeys.time) || 0);
    if (!source || !time || Date.now() - time > formReturnWindow) return null;
    return {
      source,
      x: Number(getSessionItem(formReturnKeys.x) || 0),
      y: Number(getSessionItem(formReturnKeys.y) || 0),
    };
  };
  const clearFormReturnScroll = () => {
    removeSessionItem(formReturnKeys.source);
    removeSessionItem(formReturnKeys.x);
    removeSessionItem(formReturnKeys.y);
    removeSessionItem(formReturnKeys.time);
  };
  const hideCrossFormNewsletterMessages = () => {
    const source = getSessionItem(formReturnKeys.newsletterSource);
    if (!source) return;
    doc.querySelectorAll('[data-pinme-newsletter-message]').forEach((message) => {
      if (message.getAttribute('data-pinme-newsletter-message') !== source) {
        message.hidden = true;
      }
    });
  };
  const restoreFormReturnScroll = () => {
    const record = readFormReturn();
    if (!record) {
      if (hasCustomerPostedFlag()) {
        root.classList.add('pinme-form-returning');
        window.setTimeout(() => root.classList.remove('pinme-form-returning'), 250);
      }
      if (doc.readyState === 'loading') {
        doc.addEventListener('DOMContentLoaded', hideCrossFormNewsletterMessages, { once: true });
      } else {
        hideCrossFormNewsletterMessages();
      }
      return;
    }

    root.classList.add('pinme-form-returning');
    if (record.source === 'contact-form') {
      const applyContactScroll = () => {
        if (window.location.hash.toLowerCase().includes('contact_form') && window.history?.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        window.requestAnimationFrame(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
          window.setTimeout(() => {
            root.classList.remove('pinme-form-returning');
            clearFormReturnScroll();
          }, 80);
        });
      };

      if (doc.readyState === 'loading') {
        doc.addEventListener('DOMContentLoaded', applyContactScroll, { once: true });
      } else {
        applyContactScroll();
      }
      return;
    }

    const applyScroll = () => {
      window.scrollTo({ left: record.x, top: record.y, behavior: 'auto' });
      window.requestAnimationFrame(() => {
        window.scrollTo({ left: record.x, top: record.y, behavior: 'auto' });
        hideCrossFormNewsletterMessages();
        window.setTimeout(() => {
          root.classList.remove('pinme-form-returning');
          doc.dispatchEvent(new CustomEvent('pinme:form-return-restored', { detail: { source: record.source } }));
          clearFormReturnScroll();
        }, 80);
      });
    };

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', applyScroll, { once: true });
    } else {
      applyScroll();
    }
  };
  restoreFormReturnScroll();

  const activeViewTransition = () => {
    try {
      return root.matches(':active-view-transition');
    } catch (error) {
      return false;
    }
  };
  const isRevealSuspended = () => root.classList.contains('pinme-page-transitioning')
    || activeViewTransition()
    || doc.visibilityState === 'hidden';

  const suspendReveal = () => {
    if (state.revealResumeTimer) {
      window.clearTimeout(state.revealResumeTimer);
      state.revealResumeTimer = null;
    }
    root.classList.add('pinme-page-transitioning');
  };

  const resumeReveal = () => {
    if (state.revealResumeTimer) window.clearTimeout(state.revealResumeTimer);
    state.revealResumeTimer = window.setTimeout(() => {
      root.classList.remove('pinme-page-transitioning');
      init(doc);
    }, 120);
  };

  const saveScrollState = () => ({
    x: window.scrollX || window.pageXOffset || 0,
    y: window.scrollY || window.pageYOffset || 0,
    htmlScrollBehavior: root.style.scrollBehavior,
    bodyPosition: doc.body.style.position,
    bodyTop: doc.body.style.top,
    bodyLeft: doc.body.style.left,
	    bodyRight: doc.body.style.right,
	    bodyWidth: doc.body.style.width,
	    bodyOverflow: doc.body.style.overflow,
	    bodyPaddingRight: doc.body.style.paddingRight,
	    bodyOverscroll: doc.body.style.overscrollBehavior,
	    bodyTouchAction: doc.body.style.touchAction,
	  });

  const lockScroll = (key = 'default') => {
    if (!doc.body) return () => unlockScroll(key);
    state.locks.add(key);
    if (state.saved) return () => unlockScroll(key);

	    const saved = saveScrollState();
	    const scrollbarWidth = Math.max(0, window.innerWidth - root.clientWidth);
	    state.saved = saved;
	    root.style.scrollBehavior = 'auto';
	    root.style.setProperty('--pinme-scrollbar-compensation', `${scrollbarWidth}px`);
	    root.classList.add('pinme-ui-scroll-locked');
	    doc.body.classList.add('pinme-ui-scroll-locked');
	    doc.body.style.position = 'fixed';
    doc.body.style.top = `-${saved.y}px`;
    doc.body.style.left = `-${saved.x}px`;
	    doc.body.style.right = '0';
	    doc.body.style.width = '100%';
	    doc.body.style.overflow = 'hidden';
	    if (scrollbarWidth > 0) {
	      doc.body.style.paddingRight = `${scrollbarWidth}px`;
	    }
	    doc.body.style.overscrollBehavior = 'none';
	    doc.body.style.touchAction = 'none';

    return () => unlockScroll(key);
  };

  const unlockScroll = (key = 'default') => {
    state.locks.delete(key);
    if (state.locks.size || !state.saved || !doc.body) return;

	    const saved = state.saved;
	    state.saved = null;
	    root.style.removeProperty('--pinme-scrollbar-compensation');
	    root.classList.remove('pinme-ui-scroll-locked');
	    doc.body.classList.remove('pinme-ui-scroll-locked');
    doc.body.style.position = saved.bodyPosition;
    doc.body.style.top = saved.bodyTop;
    doc.body.style.left = saved.bodyLeft;
    doc.body.style.right = saved.bodyRight;
	    doc.body.style.width = saved.bodyWidth;
	    doc.body.style.overflow = saved.bodyOverflow;
	    doc.body.style.paddingRight = saved.bodyPaddingRight;
	    doc.body.style.overscrollBehavior = saved.bodyOverscroll;
    doc.body.style.touchAction = saved.bodyTouchAction;

    window.requestAnimationFrame(() => {
      root.style.scrollBehavior = 'auto';
      window.scrollTo({ left: saved.x, top: saved.y, behavior: 'auto' });
      root.style.scrollBehavior = saved.htmlScrollBehavior;
    });
  };

  const bindPressFeedback = () => {
    if (doc.__pinmePressBound) return;
    doc.__pinmePressBound = true;

    const selector = [
      'button',
      'a[href]',
      '[role="button"]',
      '[data-pinme-add]',
      '[data-tiktok-open]',
      '[data-news-open]',
      '[data-archive-open]',
    ].join(',');

    const buttonLinkSelector = [
      '.button', '.pinme-primary', '.pinme-secondary', '.cs-primary', '.cs-outline',
      '.cs-discord-button', '.ps-button', '.vg-button', '.home-social__follow',
      '.pinme-offer-layers__button', '.pinme-decor-panel__button',
      '.pinme-cart-drawer__view-bag', '.pinme-cart-drawer__viewcart',
      '.pinme-cart-drawer__checkout', '.pinme-drawer__login',
      '.pinme-launch-tabs__button',
    ].join(',');

    const getTarget = (event) => {
      const target = event.target instanceof Element ? event.target.closest(selector) : null;
      if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return null;
      if (target.closest('[data-pinme-no-press],[data-native-product],[data-character-stage],[data-character-details],[data-native-rail],[data-review-loop]')) return null;
      if (target.matches('a[href]') && !target.matches(buttonLinkSelector)) return null;
      if (target.matches('[role="tab"], .ps-text-link, .cs-text-link, .story-link')) return null;
      if (target.closest('.ps-catalog__nav, .pinme-desktop-nav, .pinme-desktop-submenu, .pinme-drawer__nav')) return null;
      if (window.matchMedia('(max-width:767px)').matches && target.closest('[data-character-stage], [data-character-details], .pinme-product-main__media, .studio-media-dialog__stage')) return null;
      if (target.closest('.mumuse-archive-section')) return null;
      return target;
    };

    const shouldUseSoftPress = (target) => {
      if (target.closest('.mumuse-archive-section, .mumuse-archive-stack, .mumuse-hero, .mumuse-hero-scroll')) return true;
      const transform = window.getComputedStyle(target).transform;
      return Boolean(transform && transform !== 'none');
    };

    doc.addEventListener('pointerdown', (event) => {
      if (reduceMotion()) return;
      const target = getTarget(event);
      if (!target) return;
      target.classList.add(shouldUseSoftPress(target) ? 'pinme-ui-pressed-soft' : 'pinme-ui-pressed');
    }, { passive: true });

    const clear = () => doc.querySelectorAll('.pinme-ui-pressed,.pinme-ui-pressed-soft').forEach(target => target.classList.remove('pinme-ui-pressed','pinme-ui-pressed-soft'));
    ['pointerup','pointercancel'].forEach(type => doc.addEventListener(type,clear,true));
    ['blur','pagehide','pageshow'].forEach(type => window.addEventListener(type,clear));
  };
  const bindInputModality = () => {
    if (doc.__pinmeModalityBound) return;
    doc.__pinmeModalityBound = true;
    root.dataset.pinmeInput ||= 'pointer';
    doc.addEventListener('pointerdown', () => { root.dataset.pinmeInput = 'pointer'; }, { capture:true, passive:true });
    doc.addEventListener('keydown', event => {
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      if (['Tab','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','PageUp','PageDown','Enter',' '].includes(event.key)) root.dataset.pinmeInput = 'keyboard';
    }, true);
  };
  const bindFormReturnTracking = () => {
    if (doc.__pinmeFormReturnBound) return;
    doc.__pinmeFormReturnBound = true;

    doc.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.matches('[data-studio-owned-form], [data-cs-upload]')) return;
      let source = form.getAttribute('data-pinme-form-return-source') || '';
      let newsletterSource = form.getAttribute('data-pinme-newsletter-source') || '';
      if (!source && form.id === 'PinmeCustomFooterNewsletter') {
        source = 'footer-newsletter';
        newsletterSource = 'footer-newsletter';
      } else if (!source && form.id === 'PinmeEmailPopupForm') {
        source = 'popup-newsletter';
        newsletterSource = 'popup-newsletter';
      } else if (!source && form.classList.contains('pinme-contact__form')) {
        source = 'contact-form';
      }
      if (!source) return;

      setSessionItem(formReturnKeys.source, source);
      setSessionItem(formReturnKeys.x, String(window.scrollX || window.pageXOffset || 0));
      setSessionItem(formReturnKeys.y, String(window.scrollY || window.pageYOffset || 0));
      setSessionItem(formReturnKeys.time, String(Date.now()));

      if (newsletterSource) {
        setSessionItem(formReturnKeys.newsletterSource, newsletterSource);
      } else {
        removeSessionItem(formReturnKeys.newsletterSource);
      }

      root.classList.add('pinme-form-returning');
    }, true);
  };

  const isRevealCandidate = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (element.closest('[data-pinme-home-native],[data-native-product],[data-character-stage],[data-character-details],[data-studio-gallery],[data-native-community],[data-product-reviews],[data-review-submit],.pinme-header-v4,dialog,[role="dialog"]')) return false;
    if (element.closest('.mumuse-hero, .mumuse-hero-scroll, .mumuse-archive-stack, .pinme-mobile-drawer-header, .pinme-cart-drawer, .pinme-email-popup, .pinme-tiktok__modal, .pinme-custom-footer, footer')) return false;
    if (element.matches('[hidden], script, style, template')) return false;
    if (element.className && /(__bg|__background|__overlay|__backdrop|background|overlay)/.test(String(element.className))) return false;
    if (element.closest('[class*="archive"], [class*="hero"], [class*="footer"], [class*="social"], [class*="copyright"]')) return false;
    return true;
  };

  const getRevealCandidates = (scope) => {
    const sectionRoots = scope.querySelectorAll('.shopify-section > [class*="pinme-"], .shopify-section > [class*="mumuse-"]');
    const revealSelector = [
      '[data-pinme-text]',
      'h1',
      'h2',
      'h3',
      'h4',
      'p',
      'blockquote',
      'button',
      'a[href]',
      '[class*="__card"]',
      '[class*="__item"]',
      '[class*="__tile"]',
      '[class*="__panel"]',
      '[class*="__copy"]',
      '[class*="__text"]',
      '[class*="__title"]',
      '[class*="__heading"]',
      '[class*="__content"]',
      '[class*="__media"]',
      '[class*="__image"]',
      '[class*="__form"]',
      '[class*="__actions"]',
    ].join(',');
    const candidates = [];

    sectionRoots.forEach((sectionRoot) => {
      if (!isRevealCandidate(sectionRoot)) return;
      if (sectionRoot.matches('.pinme-fans, .pinme-tiktok')) {
        sectionRoot.querySelectorAll('.pinme-fans__header, .pinme-fans__viewport, .pinme-tiktok__header, .pinme-tiktok__viewport').forEach((element) => {
          candidates.push(element);
        });
        return;
      }
      sectionRoot.querySelectorAll(revealSelector).forEach((element) => {
        if (element.closest('[data-pinme-no-reveal]')) return;
        if (window.matchMedia('(max-width:767px)').matches && element.closest('[data-character-details]')) return;
        candidates.push(element);
      });
    });

    return candidates;
  };

  const hasOwnTransform = (element) => {
    const inline = element.getAttribute('style') || '';
    if (/transform\s*:|--[^:]*x|--[^:]*y|--[^:]*rot|--[^:]*scale|--[^:]*tilt|translate|rotate|scale/.test(inline)) return true;
    const className = String(element.className || '');
    if (/layer|script|mark|badge|deco|decor|tilt|rotate|stack|slide|hero|archive|footer/.test(className)) return true;
    const transform = window.getComputedStyle(element).transform;
    return Boolean(transform && transform !== 'none');
  };

  const isNearInitialViewport = (element) => {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || doc.documentElement.clientHeight || 0;
    return rect.top < viewportHeight * 1.2 && rect.bottom > -32;
  };

  const observeReveal = (scope = doc) => {
    if (reduceMotion()) return;
    if (!('IntersectionObserver' in window)) return;
    if (isRevealSuspended()) return;
    if (!state.revealObserver) {
      state.revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-pinme-visible');
          state.revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px 18% 0px', threshold: 0.08 });
    }

    const candidates = getRevealCandidates(scope);
    candidates.forEach((element) => {
      if (!isRevealCandidate(element) || state.revealSeen.has(element)) return;
      state.revealSeen.add(element);
      element.setAttribute('data-pinme-reveal', hasOwnTransform(element) ? 'fade' : 'move');
      if (isNearInitialViewport(element)) {
        element.classList.add('is-pinme-visible');
        return;
      }
      state.revealObserver.observe(element);
    });
  };

  const upgradeImages = (scope = doc) => {
    scope.querySelectorAll('img').forEach((image) => {
      if (!image.hasAttribute('decoding')) image.setAttribute('decoding', 'async');
      const isCritical = image.closest('.mumuse-hero, .pinme-mobile-head, .pinme-product-main__media');
      if (!image.hasAttribute('loading') && !isCritical) {
        image.setAttribute('loading', 'lazy');
      }
      if (!image.hasAttribute('fetchpriority') && !isCritical && image.getAttribute('loading') === 'lazy') {
        image.setAttribute('fetchpriority', 'low');
      }
    });
  };

  const init = (scope = doc) => {
    bindInputModality();
    bindPressFeedback();
    bindFormReturnTracking();
    hideCrossFormNewsletterMessages();
    upgradeImages(scope);
    observeReveal(scope);
    root.classList.add('pinme-ui-ready');
  };

  window.PinmeUI = {
    lockScroll,
    unlockScroll,
    init,
    observeReveal,
    upgradeImages,
  };

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  window.addEventListener('pagehide', suspendReveal);
  window.addEventListener('pageswap', suspendReveal);
  window.addEventListener('pageshow', resumeReveal);
  window.addEventListener('pagereveal', resumeReveal);

  doc.addEventListener('shopify:section:load', (event) => init(event.target));
})();

// The Google store widget supplies its own frame; give that known frame a useful accessible name.
(() => {
  const titleFrame = node => {
    const frame = node.id === 'merchantwidgetiframe' ? node : node.querySelector?.('#merchantwidgetiframe');
    if (!(frame instanceof HTMLIFrameElement)) return false;
    if (!frame.title.trim()) frame.title = 'Google store information';
    return true;
  };
  if (titleFrame(document)) return;
  let expiry;
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(titleFrame))) {
      observer.disconnect(); clearTimeout(expiry);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  expiry = setTimeout(() => observer.disconnect(), 30000);
})();
